import React, { useEffect, useRef, useState } from "react";
import { Image } from "react-bootstrap";
import es_ES from "rsuite/locales/es_ES";
import {
  Input,
  Button,
  DatePicker,
  SelectPicker,
  InputGroup,
  VStack,
  HStack,
  Form,
  Stack,
  Panel,
  NumberInput,
  Text,
  Message,
  toaster,
  Card,
  Avatar,
  TagGroup,
  Tag,
  CustomProvider,
  Divider,
} from "rsuite";
import { FaPhone, FaUserAlt } from "react-icons/fa";
import moment from "moment/moment";
import {
  getConsultorio,
  getPaciente,
  getHorarios,
  saveCita,
} from "../Services/ConsultasServices";

export const FisioTerapia = () => {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>           SE ASIGNA ESTA CONTANTE DE ACUERDO AL NUMERO DE CLIENTE y EL NOMBRE DE LA PAGINA
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>           IMPORTANTE CAMBIAR ESTAS DOS LINEAS CUANDO SE ABRA OTRO NEGOCIO
  const [idNegocio] = useState(2);
  const [idMedico] = useState(1);
  const [negocio] = useState("Fisioterapia");
  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

  const [ubica, setUbica] = useState("");
  const [domicilio, setDomicilio] = useState("");
  const [estado, setEstado] = useState("");
  const [telefono, setTelefono] = useState("");
  const [fecha, setFecha] = useState("");
  const [nombre, setNombre] = useState("");
  const [idPaciente, setPaciente] = useState(0);
  const [disableNom, setDisableNom] = useState(true);
  const [disableFec, setDisableFec] = useState(true);
  const [disableHors, setDisableHors] = useState(true);
  const [dataHorarios, setDataHorarios] = useState([]);
  const [disableBtn, setDisableBtn] = useState(true);
  const [hora, setHora] = useState("");
  const [dislpayMsg, setDisplayMsg] = useState("none");
  const [showHorarios, setShowHorarios] = useState("block");
  const [titulo, setTitulo] = useState("");
  const [medico, setMedico] = useState("");
  const [servicios, setServicios] = useState([]);
  const [medicos, setMedicos] = useState([]);
  const [telNegocio, setTelNegocio] = useState("");
  // const [openRating, setOpenRating] = useState(false);

  const effectRan = useRef(false);

  const goTo = (page, windowOut) => {
    if (windowOut === 0) {
      window.location = `/#/${page}`;
    } else {
      window.open(page, "_blank");
    }
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  };

  const getData = async () => {
    await getConsultorio(idNegocio, idMedico).then((response) => {
      setUbica(response.ubica);
      setDomicilio(response.domicilio + ", " + response.colonia);
      setEstado(response.estado + ", " + response.municipio);
      setTitulo(response.titulo);
      setMedico(response.medico);
      setServicios(response.servicios);
      setMedicos(response.medicos);
      setTelNegocio(response.telefonos);
    });
  };

  const fetchPaciente = async (valueTel) => {
    setTelefono(valueTel);
    const response = await getPaciente(idNegocio, valueTel);
    setDisableNom(false);
    if (response.status === 204) {
      setNombre("");
      setPaciente(0);
    } else {
      setNombre(response.nombre);
      setPaciente(0);
      setDisableFec(false);
    }
  };

  const handleChangeTelefono = async (value) => {
    if (value) {
      if (value.length === 10) {
        fetchPaciente(value);
      } else {
        setNombre("");
        setPaciente(0);
      }
    } else {
      setNombre("");
      setPaciente(0);
    }
  };

  const handleNombre = (e) => {
    setNombre(e.toUpperCase());
    if (e.length > 0) {
      setDisableFec(false);
    } else {
      setDisableFec(true);
    }
  };

  const fetchHorarios = async (fecha) => {
    setFecha(fecha);
    const response = await getHorarios(idNegocio, fecha);
    if (response.length === 0) {
      setShowHorarios("none");
      setDisplayMsg("block");
    }
    setDataHorarios(response);
  };

  const handleChangeFec = (e) => {
    if (e != null) {
      var fecha = new Date(e).toISOString();
      setShowHorarios("block");
      setDisableHors(false);
      fetchHorarios(fecha);
    } else {
      setShowHorarios("block");
      setDisplayMsg("none");
      setDataHorarios([]);
    }
  };

  const handleHorario = (e) => {
    if (e === null) {
      setHora("");
      setDisableBtn(true);
    } else {
      setHora(e);
      setDisableBtn(false);
    }
  };

  const save = async () => {
    const dataCita = {
      id: idNegocio,
      idPaciente: idPaciente,
      negocio: negocio,
      nomConsultorio: "",
      fecha: fecha.substring(0, 10),
      hora: hora,
      nombre: nombre,
      telefono: telefono,
      correo: "",
      domicilio: domicilio,
      edoMun: estado,
      descripCita: "",
      telNegocio: telNegocio,
    };

    await saveCita(dataCita)
      .then((res) => {
        if (res === -1) {
          toast("El horario no se encuentra disponible.", "warning");
          return;
        }

        localStorage.setItem("dataCita", JSON.stringify(dataCita));
        const uuid = {
          uuidCita: res.data,
        };

        localStorage.setItem("uuidCita", JSON.stringify(uuid));
        window.location = `/#/CitaConfirmada/${idNegocio}/${telefono}`;
      })
      .catch((error) => {
        toast(
          "La fecha y hora de la cita, ya ha sido apartada, intente con otros datos.",
          "warning"
        );
        console.log(error);
      });
  };

  const handleDisabledDate = (date) => {
    return date.getTime() < moment().startOf("day").valueOf();
  };

  useEffect(() => {
    if (!effectRan.current) {
      effectRan.current = true;
      getData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, []);

  return (
    <>
      <br></br>
      <Stack
        alignItems="center"
        justifyContent="center"
        style={{ height: "100%" }}
      >
        <Panel bordered style={{ width: 340, backgroundColor: "#e0e6ec" }}>
          <VStack>
            <Card shaded>
              <Card.Header>
                <HStack>
                  <Avatar
                    circle
                    src={`Images/Negocios/${idNegocio}/foto.jpg`}
                  />
                  <VStack spacing={2}>
                    {medicos.length > 0
                      ? medicos.map((itm, index) => {
                          return <Text key={index}>{itm.nombre}</Text>;
                        })
                      : ""}
                    <Text muted size="sm">
                      {titulo}
                    </Text>
                  </VStack>
                </HStack>
              </Card.Header>
              <Card.Body>
                <TagGroup>
                  {servicios.length > 0
                    ? servicios.map((itm, index) => {
                        return (
                          <Tag size="md" key={index}>
                            {itm}
                          </Tag>
                        );
                      })
                    : ""}
                </TagGroup>
              </Card.Body>
              {/* <Card.Footer>
                  <Text muted>Joined in January 2023</Text>
                </Card.Footer> */}
            </Card>
          </VStack>
          <p></p>
          <Form fluid>
            <Form.Group>
              <Form.ControlLabel>
                <Text>Número de celular</Text>
              </Form.ControlLabel>
              <InputGroup>
                <InputGroup.Addon>
                  <FaPhone />
                </InputGroup.Addon>
                <NumberInput
                  controls={false}
                  id="telefono"
                  autoFocus
                  onChange={(e) => handleChangeTelefono(e)}
                  maxLength={10}
                  min={0}
                />
              </InputGroup>
              <span>
                <Text muted size="sm">
                  El número debe tener 10 digitos
                </Text>
              </span>
            </Form.Group>

            <Form.Group>
              <Form.ControlLabel>
                <Text>Nombre completo</Text>
              </Form.ControlLabel>
              <InputGroup>
                <InputGroup.Addon>
                  <FaUserAlt />
                </InputGroup.Addon>
                <Input
                  id="nombre"
                  value={nombre}
                  onChange={(e) => handleNombre(e)}
                  disabled={disableNom}
                />
              </InputGroup>
            </Form.Group>

            <Form.Group>
              <Form.ControlLabel>
                <Text>Fecha</Text>
              </Form.ControlLabel>
              <CustomProvider locale={es_ES}>
                <DatePicker
                  block
                  shouldDisableDate={handleDisabledDate}
                  disabled={disableFec}
                  onChange={(e) => handleChangeFec(e)}
                />
              </CustomProvider>
            </Form.Group>

            <Form.Group>
              <Form.ControlLabel>
                <Text>Horarios disponibles</Text>
              </Form.ControlLabel>
              <InputGroup id="horarios" style={{ display: showHorarios }}>
                <SelectPicker
                  style={{ width: "auto" }}
                  block
                  searchable={false}
                  data={dataHorarios}
                  disabled={disableHors}
                  onChange={(e) => handleHorario(e)}
                  placeholder="Selecciona un horario"
                />
              </InputGroup>
              <Message
                type="warning"
                bordered
                showIcon
                style={{ display: dislpayMsg }}
              >
                No hay horarios disponibles en la fecha seleccionada.
              </Message>
            </Form.Group>

            <Button
              appearance="primary"
              block
              disabled={disableBtn}
              onClick={() => save()}
            >
              Enviar
            </Button>
          </Form>
          <p></p>
          <table>
            <tr>
              <td rowSpan="3" width="20%">
                <Image
                  src="Images/mapPoint.jpg"
                  height={"30px"}
                  style={{
                    borderRadius: "10%",
                    cursor: "pointer",
                    padding: "2px",
                  }}
                  onClick={() => goTo(ubica, 1)}
                />
              </td>
            </tr>
            <tr>
              <td>
                <Text weight="light" size="sm">
                  <a
                    href={ubica}
                    rel="noreferrer"
                    target="_blank"
                    style={{ textDecoration: "none", color: "blue" }}
                  >
                    {domicilio}
                  </a>
                </Text>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "left" }}>
                <Text size="sm">{estado}</Text>
              </td>
            </tr>
          </table>
        </Panel>
      </Stack>
      <center>
        {/* <div style={{ paddingTop: "2px" }}>
          <FaHandPointRight color="blue"></FaHandPointRight>
          <Button
            appearance="subtle"
            size="sm"
            style={{ color: "blue" }}
            onClick={() => setOpenRating(true)}
          >
            (0) Opiniones
          </Button>
          <Rate defaultValue={5} color="yellow" size="sm" />
        </div> */}
        <Image
          src="/Images/Logo.png"
          style={{ height: 100, padding: "10px" }}
        />
        <p style={{ fontSize: "12px", color: "#CCCACA" }}>
          <b>Version: 1.1.22</b>
        </p>
      </center>
      {/* PENDIENTE HASTA CONCOCER TEMAS LEGALES PARA PUBLICAR OPINIONES */}
      {/* <Drawer
        size="full"
        placement="right"
        open={openRating}
        onClose={() => setOpenRating(false)}
      >
        <Drawer.Header>
          <Drawer.Title>Tu opinión es muy importante</Drawer.Title>
          <Drawer.Actions>
            <Button onClick={() => setOpenRating(false)} appearance="primary">
              Cerrar
            </Button>
          </Drawer.Actions>
        </Drawer.Header>
        <Drawer.Body>
          <div className="row mb-3">
            <div className="col">

            </div>
          </div>
          <div className="row">
            <div className="col"></div>
          </div>
        </Drawer.Body>
      </Drawer> */}
    </>
  );
};
